<template>
  <form class="pt-4 pb-4">
    <div class="form-group">
      <label>University</label>
      <ValidationProvider rules="required" v-slot="{ errors }">
        <UniversityInput class="form-control col-3" v-model="university"/>
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label>Mail Template Name</label>
      <ValidationProvider rules="required" v-slot="{ errors }">
        <input type="text" class="form-control" v-model="name">
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label>Target</label>
      <ValidationProvider rules="required" v-slot="{ errors }">
        <select class="form-control w-25" v-model="target">
          <option></option>
          <option v-for="(name, type) of targets" :key="type" :value="type">
            {{ name }}
          </option>
        </select>
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label>Notification</label>
      <ValidationProvider rules="required" v-slot="{ errors }">
          <select class="form-control w-25" v-model="notification" :disabled="target === 'tutor'">
            <option></option>
            <option v-for="(name, type) of notifications" :value="type" :key="type">
              {{ name }}
            </option>
          </select>
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label>Month</label>
      <ValidationProvider rules="required" v-slot="{ errors }">
        <select class="form-control w-25" v-model="month">
          <option></option>
          <option
            v-for="month of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
            :value="month" :key="month"
          >
            {{ month }}
          </option>
        </select>
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label>Subject</label>
      <ValidationProvider rules="required" v-slot="{ errors }">
        <input type="text" class="form-control" v-model="subject">
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label>Text</label>
      <ValidationProvider rules="required" v-slot="{ errors }">
        <textarea rows="5" class="form-control" v-model="body"></textarea>
        <div class="error-text">{{ errors[0] }}</div>
      </ValidationProvider>
    </div>
  </form>
</template>

<script lang="ts">
import _ from 'lodash'
import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator'
import { extend, ValidationProvider } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import UniversityInput from '@/components/parts/inputItem/SelectUniversityInput.vue'
import {
  MailNotifications,
  mailNotificationType,
  MailTargets,
  mailTargetType,
} from '@/store/mails/types'
import { MailTemplate } from '@/store/mails/templates/types'
import { University } from '@/store/master/types'

extend('required', rules.required)
extend('required', { message: 'required.' })

@Component({
  components: {
    UniversityInput,
    ValidationProvider,
  },
})
export default class MailTemplateInputForm extends Vue {
  @Prop() initContents!: MailTemplate

  private targets = MailTargets

  private notifications = MailNotifications

  private university: University|null = null

  private name: string = ''

  private target: mailTargetType|null = null

  private notification: mailNotificationType|null = null

  private month: number|null = null

  private subject: string = ''

  private body: string = ''

  get contents(): MailTemplate|Object {
    return {
      university: this.university as University,
      name: this.name,
      target: this.target as mailTargetType,
      notification: this.notification as mailNotificationType,
      month: this.month as number,
      subject: this.subject,
      body: this.body,
    }
  }

  @Watch('initContents', { deep: true, immediate: true })
  private changeInitContents() {
    this.university = this.initContents?.university
    this.name = this.initContents?.name
    this.target = this.initContents?.target
    this.notification = this.initContents?.notification
    this.month = this.initContents?.month
    this.subject = this.initContents?.subject
    this.body = this.initContents?.body
  }

  @Watch('target')
  private fixNotificationType() {
    if (this.target === 'tutor') {
      this.notification = 'mail'
    }
  }
}
</script>
